import $ from "jquery"
import "datatables.net"
import "datatables.net-dt/css/jquery.datatables.css"
// table
$(document).ready(function () {
    // @ts-ignore
    var table = $('.filtered_table').DataTable({ 'scrollX': true, 'autoWidth': false, 'order': [] })
    $('.dataTables_length').addClass('bs-select');
});